import "../js/vendor/jquery.fitvids";
import "../js/navigation";
import "../js/skip-link-focus-fix";

(function ($) {
	"use strict";

	$(".featured-slider__carousel").slick({
		dots: getThemeMod.sliderDotNavigation ? true : false,
		arrows: getThemeMod.sliderArrowNavigation ? true : false,
		infinite: true,
		fade: getThemeMod.sliderAnimation == "fade" ? true : false,
		speed: getThemeMod.sliderAnimationSpeed
			? parseInt(getThemeMod.sliderAnimationSpeed)
			: 500,
		autoplay: getThemeMod.sliderAutoplay ? true : false,
		autoplaySpeed: getThemeMod.sliderAutoplaySpeed
			? parseInt(getThemeMod.sliderAutoplaySpeed)
			: 5000,
		nextArrow:
			'<button class="featured-slider__arrow button--nostyle next" aria-label="Next">' +
			icons.chevronRight +
			"</button>",
		prevArrow:
			'<button class="featured-slider__arrow button--nostyle prev" aria-label="Previous">' +
			icons.chevronLeft +
			"</button>",
	});

	// Add chevron icons to menu items with children
	$(".navigation > div > ul > li.menu-item-has-children").append(
		'<span class="sub-menu-toggle">' + icons.chevronDown + "</span>"
	);
	$(".navigation > div > ul > li > ul > li.menu-item-has-children").append(
		'<span class="sub-menu-toggle">' + icons.chevronRight + "</span>"
	);

	// Toggle submenus within the mobile navigation menu
	$(".navigation--reponsive li")
		.has("ul")
		.append(
			'<button class="navigation--reponsive-arrow button--nostyle" aria-expanded="false">' +
				icons.chevronDown +
				"</button>"
		);

	// Handle clicking of mobile menu dropdown button
	$(".navigation--reponsive li .navigation--reponsive-arrow").click(
		function () {
			// Dropdown button
			var dropDownButton = $(this);
			// Dropdown Icon
			var svg = dropDownButton.find(".icon");
			// Holds the icons 'use' element
			var svgUse = dropDownButton.find(".icon").find("use");

			if (svgUse.attr("href") == "#icon-chevron-down") {
				dropDownButton.attr("aria-expanded", "true");
				svgUse.attr("href", "#icon-chevron-up");
				svgUse.attr("xlink:href", "#icon-chevron-up");
				svg.removeClass("icon-chevron-down");
				svg.addClass("icon-chevron-up");
			} else {
				dropDownButton.attr("aria-expanded", "false");
				svgUse.attr("href", "#icon-chevron-down");
				svgUse.attr("xlink:href", "#icon-chevron-down");
				svg.addClass("icon-chevron-down");
				svg.removeClass("icon-chevron-up");
			}

			// Toggle sub menus
			$(this).parent().find("ul:first").slideToggle(200);
		}
	);

	// Toggle classes required to animate the fly-out sidebar and overlay.
	$(".toggle-flyout").click(function () {
		// Accessibility
		$(this).attr("aria-expanded", "true");
		// Add class to animate
		$(".sidebar-flyout").addClass("is-active");
		$(".sidebar-flyout-overlay").addClass("is-active");
	});

	$(".toggle-search").click(function () {
		// Accessibility
		$(this).attr("aria-expanded", "true");
		// Add class to animate
		$(".site__search").addClass("is-active");
		$(".site__search .search-field").focus();
	});

	$(".site__search-close").click(function () {
		$(".site__search").attr("aria-expanded", "false");
		$(".site__search").removeClass("is-active");
	});

	// Close the fly-out sidebar when the close icon is clicked
	$(".sidebar-flyout-close").click(function () {
		$(".toggle-flyout").attr("aria-expanded", "false");
		$(".sidebar-flyout").removeClass("is-active");
		$(".sidebar-flyout-overlay").removeClass("is-active");
	});

	// Close the fly-out sidebar when the overlay is clicked
	$(".sidebar-flyout-overlay").click(function () {
		$(".sidebar-flyout").removeClass("is-active");
		$(".sidebar-flyout-overlay").removeClass("is-active");
	});

	// Toggle comments
	$(".comments__toggle-button").click(function () {
		// Accessibility
		if ($(this).attr("aria-expanded") == "false") {
			$(this).attr("aria-expanded", "true");
		} else {
			$(this).attr("aria-expanded", "false");
		}

		// Add class to animate
		$(".comments__area").toggleClass("is-active");

		if (
			$(this).find("span:first-child").html() == localize.toggleCommentsShow
		) {
			$(this).find("span:first-child").html(localize.toggleCommentsHide);
		} else {
			$(this).find("span:first-child").html(localize.toggleCommentsShow);
		}
	});

	// FitVids @link http://fitvidsjs.com/
	$(document).ready(function () {
		$(".page,.post").fitVids();
	});
})(jQuery);


